module.exports = __webpack_public_path__ + "static/media/09C.c3361de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/09C.png
// module id = 284
// module chunks = 0